import { callEndpoint } from './apiUtils';

const isStartVideoSuccessResponse = (response: StartVideoResponse): response is StartVideoSuccessResponse => {
  if (!response || !response.STATUS) {
    return false;
  }
  return response.STATUS === 'SUCCESS';
};

export const startVideoApi = async (jwt: string, region: string = 'us-east-1', readinessCheck = false) => {
  const response: StartVideoResponse = await callEndpoint(
    `start-video?region=${region}&readinessCheck=${readinessCheck}`,
    jwt,
    'POST'
  );

  if (!isStartVideoSuccessResponse(response)) {
    const errorText = response?.STATUS ? `response.status ${response.STATUS}` : `Server Error Occured for start-video`;
    throw new Error(errorText);
  } else {
    return response;
  }
};
